import React, { Component } from 'react';
import Table, { ColumnProps } from 'antd/lib/table';
import umbrella from 'umbrella-storage';
import Cookies from 'js-cookie';
import AdminService, { AdminListRequest, AdminPutParam, IAdminInfo, IAdminInfoList } from '../../service/admin/AdminService';
import { getRoleName } from './AdminPage';
import { IAdminRoleInfo } from '../../service/admin/AdminRoleService';
import './page-admin.less';
import { message } from 'antd';
import * as strcfg from '../../config/strcfg';
import { States, getStates } from '../../components/public/StatesSelect';

interface AdminTableProps {
    roleOptions: IAdminRoleInfo[];
}

interface AdminTableState {
    pageData: IAdminInfoList | null;
    sourceData: AdminTableRow[];
    accInputValue: string;
    nameInputValue: string;
    roleSelectValue: number | null;
    statesSelectValue: number | null;
    pagination: any;
}

interface AdminTableRow extends IAdminInfo {
    roleLabel: string;
}

//获取pageSize
const defaultPageSize = 5;
const getPageSize = () => {
    return umbrella.getLocalStorage('adminPageSize') ? umbrella.getLocalStorage('adminPageSize') : defaultPageSize;
}

const ROLE_PARTS = [1000, 100, 10, 2, 1];
const splitRole = (roleValue: number) => {
    const result: number[] = [];
    if (!roleValue || roleValue <= 0) {
        return result;
    }
    let remain = roleValue;
    ROLE_PARTS.forEach((part) => {
        if (remain >= part) {
            remain -= part;
            result.push(part);
        }
    });
    if (remain !== 0) {
        return [roleValue];
    }
    return result;
};

//自定义AdminTable
class AdminTable extends Component<AdminTableProps, AdminTableState> {

    state: AdminTableState = {
        pageData: {
            records: [],
            total: 0,
            size: 0,
            current: 0,
            pages: 0
        },
        sourceData: [],
        accInputValue: null,
        nameInputValue: null,
        roleSelectValue: null,
        statesSelectValue: null,
        pagination: null
    };

    //定义表格的列属性
    columns: ColumnProps<any>[] = [
        { title: 'id', width: 30, dataIndex: 'id', key: 'id', fixed: 'left' },
        { title: 'Account', width: 58, dataIndex: 'account', key: 'account' },
        { title: '用户名', width: 80, dataIndex: 'realName', key: 'realName' },
        {
            title: '权限',
            width: 90,
            dataIndex: 'roleLabel',
            key: 'role',
            render: (roleText: string) => <div style={{ whiteSpace: 'pre-line', lineHeight: '18px' }}>{roleText}</div>,
        },
        { title: '头像', width: 50, dataIndex: 'avatar', key: 'avatar' },
        { title: '状态', width: 50, dataIndex: 'states', key: 'states' },
        {
            title: '操作',
            key: 'operation',
            fixed: 'right',
            width: 100,
            render: (record: AdminTableRow) => (
                <>
                    <button onClick={() => this.handleEditBottonClick(record)}>编辑</button>
                    {record.states.toString() === getStates(States.normal) ? (
                    <button onClick={() => this.handleStateChangeBottonClick(record, States.forbbinden)}>禁用</button>
                    ) : (
                    <button onClick={() => this.handleStateChangeBottonClick(record, States.normal)}>启用</button>
                    )}          
                </>
            ),
        },
    ];

    //获取指定页码的查询数据
    getAdminTableData = async (pageNo: number, role: number, account?: string, realName?: string, states?: number) => {
        //设置state
        this.state.roleSelectValue = role;

        if(account !== undefined){ 
            this.state.accInputValue = account;
        }
        if(realName !== undefined){
            this.state.nameInputValue = realName;
        }
            
        if(states !== undefined){
            this.state.statesSelectValue = states;
        }
        
        //构造请求
        const request: AdminListRequest = {
            adminQueryParam: {
                account: this.state.accInputValue === null ? '' : this.state.accInputValue,
                realName: this.state.nameInputValue === null ? '' : this.state.nameInputValue,
                role: this.state.roleSelectValue === null ? undefined : this.state.roleSelectValue,
                states: this.state.statesSelectValue === null ? undefined : this.state.statesSelectValue,
            },
            pageNo,
            pageSize: getPageSize(),
        };
        //处理返回
        const response = await AdminService.getAdminListInfo(request);
        if (response) {
            const pageData: IAdminInfoList = response.data && response.data.adminInfoList ? response.data.adminInfoList : [];
            const adminRecords = pageData && pageData.records ? response.data.adminInfoList.records : [];
            const mappedSourceData: AdminTableRow[] = adminRecords.map((item: any) => ({
                id: item.id,
                account: item.account,
                role: item.role,
                roleLabel: getRoleName(item.role, this.props.roleOptions),
                realName: item.realName,
                avatar: item.avatar,
                states: getStates(item.states),
            }));
            this.setState((prevState) => ({
                ...prevState,
                pageData: pageData,
                sourceData: mappedSourceData,
                pagination: {
                    ...prevState.pagination,
                    total: pageData.total,
                  },
            }));
        }
    };
  
    //页码切换事件
    handleChangePage = async (pageNo: number) => {
        await this.getAdminTableData(pageNo, this.state.roleSelectValue);
        this.state.pageData.current = pageNo;
        this.setState((prevState) => ({
            ...prevState,
            pagination: { ...prevState.pagination, current: pageNo },
        }));
    };
  
    //PageSize选项卡事件
    changePageSize = async (current: number, pageSize: number) => {
        umbrella.setLocalStorage('adminPageSize', pageSize);
        // 将当前改变的每页条数存到state中, 变更页面记录数后默认返回第一页数据
        this.setState((prevState) => ({
            ...prevState,
            pagination: { ...prevState.pagination, current, pageSize },
        }));
        await this.getAdminTableData(this.state.pageData.current, this.state.roleSelectValue);
    };

    //编辑按钮事件
    handleEditBottonClick = (adminData: AdminTableRow) => {
        const currentRole = parseInt(Cookies.get('userRole') || '0', 10);
        const currentRoleParts = splitRole(currentRole);
        const targetRoleParts = splitRole(adminData.role);
        const canEditAdminRoleAccount = currentRoleParts.includes(1000);
        const loginAccount = umbrella.getLocalStorage('user')?.account;
        const isSelfEditing = loginAccount === adminData.account;
        const targetIsAdminOrAbove = targetRoleParts.includes(100)
            || targetRoleParts.includes(1000)
            || adminData.role >= 100;

        if (!canEditAdminRoleAccount
            && !isSelfEditing
            && targetIsAdminOrAbove) {
            message.error('仅超级管理员可编辑管理员及超级管理员账号');
            return;
        }
        // 跳转管理员管理页面
        const queryString = `?id=${adminData.id}`; 
        window.location.href = '/#/app/admin/manager' + queryString;
    }

    //启用、禁用按钮事件
    handleStateChangeBottonClick = async (adminData: IAdminInfo, states: number) => {
        const loginAccount = umbrella.getLocalStorage('user').account;
        const operatingAccount = adminData.account;
        if(loginAccount === operatingAccount && states !== 0){
            message.error(strcfg.INVALID_ADMIN_OPERATION_ERROR_MESSAGE);
            return;
        }
        const tips = states !== 0 ? strcfg.INVALID_ADMIN_CONFIRM_MESSAGE : strcfg.VALID_ADMIN_CONFIRM_MESSAGE;
        if (window.confirm(tips)) {
            const request: AdminPutParam = { id: 0, states: 0 };
            request.id = adminData.id;
            request.states = states;
            //调用启用or禁用接口
            const response = await AdminService.updateAdmin(request);
            if (response) {
                //启用or禁用成功，重新加载数据
                await this.getAdminTableData(this.state.pageData.current, this.state.roleSelectValue); 
            } 
        }
    }

    render() {
        const sourceData = this.state.sourceData;
        const dataArray: AdminTableRow[] = Array.isArray(sourceData) ? sourceData : [];
        const dataWithKeys = dataArray.map((row: AdminTableRow, index: number) => ({ ...row, key: index }));
    
        return (
            <Table
                columns={this.columns}
                dataSource={dataWithKeys}
                pagination={{
                    showSizeChanger: true,
                    current: this.state.pageData ? this.state.pageData.current : 1,
                    pageSize: getPageSize(),
                    total: this.state.pageData ? this.state.pageData.total : 0,
                    pageSizeOptions: ['5','10','20','50','100'],
                    showTotal: (total: number, range: [number, number]) => `显示第 ${range[0]} 到第 ${range[1]} 条记录，共 ${total} 条记录`,
                    onShowSizeChange: (current, pageSize) => this.changePageSize(current, pageSize),
                    onChange: this.handleChangePage,
                }}
                scroll={{ x: 800 }}
            />
        );
    }

};

export default AdminTable;
